"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cazzago-san-martino": {
    "312bbdce": [{
      "hkey": "afff3409",
      "slug": "costa-barco",
      "name": "Costa-Barco",
      "primary": true,
      "skipSearch": false
    }],
    "barco": [{
      "hkey": "afff3409",
      "slug": "costa-barco",
      "name": "Costa-Barco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cazzago-san-martino"
    }],
    "e85c1ef4": [{
      "hkey": "afff3409",
      "slug": "costa-barco",
      "name": "Costa-Barco",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "afff3409",
      "slug": "costa-barco",
      "name": "Costa-Barco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;